// Clear only the form belonging to a confirmed write, never an unrelated draft.
export function captureDiscussionDraft(form) {
    return Array.from(form.elements).filter(field =>
        !['submit', 'button', 'reset', 'file'].includes(field.type)
        && !['_token_', '_do'].includes(field.name)
    ).map(field => ({ field, value: field.value, checked: field.checked }));
}

export function clearStoredDiscussionDraft(form, draft, payload) {
    if (payload?.discussionStored !== true || !form.isConnected) return false;
    if (draft.some(({ field, value, checked }) => field.value !== value || field.checked !== checked)) return false;

    // reset() alone restores HTML defaults, which can contain a previous POST.
    form.querySelectorAll('textarea, input[type="text"], input[type="url"], input:not([type])').forEach(field => {
        field.value = '';
        field.defaultValue = '';
        field.style.removeProperty('height');
        if (field.tagName === 'TEXTAREA' && form.dataset.discussionForm === 'comment') {
            field.placeholder = form.matches('[data-match-comment-form]')
                ? 'Napište komentář k zápasu…' : 'Napište komentář…';
        }
    });
    const reply = form.elements.namedItem('reply_to_comment_id');
    if (reply) reply.value = '0';
    form.querySelector('[data-discussion-link-preview]')?.replaceChildren();
    form.querySelector('[data-discussion-link-preview]')?.classList.add('hidden');
    form.querySelector('[data-discussion-submit-error]')?.remove();
    form.querySelectorAll('textarea').forEach(field => field.dispatchEvent(new Event('input', { bubbles: true })));
    form.dispatchEvent(new CustomEvent('discussion:stored', { bubbles: true }));
    return true;
}
